// date - в формате числовой даты в ответе на запрос к бэку
export const getDateTimeDiff = (date: number): number =>
  date - new Date().getTime() / 1000;
